<template>
	<v-combobox
		class="input-chipbox"
		:items="items"
		:label="label"
		:placeholder="placeholder"
		:hint="hint"
		:color="color"
		:disabled="disabled"
		multiple
		small-chips
		deletable-chips
		hide-details
		:value="selected"
		:clear-icon="null"
		:append-icon="noSelection ? null : '$dropdown'"
		@input="onInput($event)"
		@change="onChange($event)"
	/>
</template>

<script>
export default {
	props: {
		items: {
			type: Array,
			default: () => [],
		},
		color: String,
		disabled: Boolean,
		label: String,
		placeholder: String,
		hint: String,
		value: Array,
		noSelection: Boolean,
		multiple: Boolean,
	},
	computed: {
		selected() {
			if (!this.value) { return [] }
			return this.value
				.map(value => this.items.find(item => (typeof item === 'string' ? item === value : item.value === value)))
				.filter(value => !!value)
		},
	},
	methods: {
		onInput(event) {
			this.$emit('input', event.map(item => (typeof item === 'string' ? item : item.value)))
		},
		onChange(event) {
			this.$emit('change', event.map(item => (typeof item === 'string' ? item : item.value)))
		},
	},
}
</script>

<style scoped>
</style>
